import { Fragment, useEffect } from "react";
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import { classNames } from "../../../helpers/classNames";
import Button from "../../form/front/Button";

const Modal = ({
  title,
  subtitle,
  children,
  isOpen = false,
  onClose = () => { },
  size = "xl4",
  modalDialogueStyle = "",
  modalBodyClass = "",
  header,
  closeBtn = true,
  bodyClasses,
  isOutsideClose = true,
  titleClass,
  headerClass,
  drawer = false,
  closeOnEsc = true,
  backdrop = true,
  animation = "scale", // 'scale', 'slide', 'fade'
  modalFooter = () => { },
}) => {
  const modalSize = {
    xs: "sm:max-w-xs",
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    xl2: "sm:max-w-2xl",
    xl3: "sm:max-w-3xl",
    xl4: "sm:max-w-4xl",
    xl5: "sm:max-w-5xl",
    xl6: "sm:max-w-6xl",
    xl7: "sm:max-w-7xl",
    xl8: "sm:max-w-8xl",
    xl9: "sm:max-w-9xl",
    full: "max-w-full",
  };

  const getAnimationClasses = () => {
    switch (animation) {
      case "slide":
        return {
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          enterTo: "opacity-100 translate-y-0 sm:scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
          leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        };
      case "fade":
        return {
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
        };
      default: // scale
        return {
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
        };
    }
  };

  const animationClasses = getAnimationClasses();



useEffect(() => {
  if (isOpen) {
    document.body.classList.add("modal-open");
    document.documentElement.classList.add("modal-open");
  } else {
    document.body.classList.remove("modal-open");
    document.documentElement.classList.remove("modal-open");
  }

  return () => {
    document.body.classList.remove("modal-open");
    document.documentElement.classList.remove("modal-open");
  };
}, [isOpen]);



  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[51]" onClose={isOutsideClose ? onClose : () => { }} static={!closeOnEsc}>
        {/* Backdrop */}
        {backdrop && (
          <TransitionChild as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
            <div className="fixed inset-0 bg-[rgba(0,0,0,0.75)]" />
          </TransitionChild>
        )}

        {/* Modal Container */}
        <div className="fixed inset-0 overflow-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center overflow-hidden">
            <TransitionChild as={Fragment} enter={animationClasses.enter} enterFrom={animationClasses.enterFrom} enterTo={animationClasses.enterTo} leave={animationClasses.leave} leaveFrom={animationClasses.leaveFrom} leaveTo={animationClasses.leaveTo}>
              <DialogPanel className={classNames("w-full transform overflow-hidden text-left align-middle shadow-2xl transition-all rounded-2xl", modalSize[size], modalBodyClass)}>
                <div className={classNames("rounded-2xl bg-white dark:bg-darkBg relative border dark:border-gray-500 border-shades-03", modalDialogueStyle)}>
                  {/* Header */}
                  {header !== false && (
                    <div className="relative flex-shrink-0">
                      {header ? (
                        header
                      ) : (
                        <div className={classNames("relative h-16 py-0 px-4 flex items-center justify-between border-b dark:border-gray-500 border-shades-07 bg-white dark:bg-darkBg rounded-t-2xl", headerClass)}>
                          <div className="flex-1 min-w-0">
                            {title && (
                              <DialogTitle as="h3" className={classNames("text-xl xls:text-2xl font-bold text-black dark:text-white", titleClass)}>
                                {title}
                              </DialogTitle>
                            )}
                            {subtitle && <div className="mt-1 text-sm text-gray-500 truncate">{subtitle}</div>}
                          </div>

                          {closeBtn && (
                            <div className="ml-4 flex-shrink-0">
                              <Button buttonIcon={"fa-light fa-xmark text-2xl dark:text-white"} buttonIconPosition={"left"} buttonClasses={"!h-10 aspect-square !px-0 !text-black hover: !bg-transparent"} buttonFunction={onClose} />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Body */}
                  <div className={classNames("relative p-3 md:p-6", bodyClasses)}>{children}</div>
                  {modalFooter && modalFooter()}
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
